/*eslint-disable-*/
import axios from "axios";

export default {
    methods: {
        GTMCheckoutEvents(cart) {
            let products = this.prepareProductsForEvents(cart)
            this.$gtm.trackEvent({
                'event': 'eec.checkout',
                'ecommerce': {
                    'checkout': {
                        'actionField': {'step': 1, 'option': 'Submit'},
                        products
                    }
                }
            });
            this.payBtnId = 'ga_payment_button';
        },
        WebengageSetUserLoggedIn(userID) {
            if (window.webengage && localStorage.getItem('webengage_login') != 'true') {
                window.webengage.user.login(userID);
                localStorage.setItem('webengage_login', true)
            }
        },
        WebengageSetUserRequiredFiled(profile) {
            this.WebengageSetUserLoggedIn(profile.id)
            if (window.webengage) {
                if (profile.email) {
                    window.webengage.user.setAttribute("we_email", profile.email);
                }
                if (profile.cel) {
                    window.webengage.user.setAttribute("we_phone", profile.cel.replaceAll(' ', ''));
                }
            }
        },
        WebengageUserRegister(userId, register_on, email, phone = null, fromTest = false) {
            if (window.webengage) {
                try {
                    if (register_on) {
                        window.webengage.user.setAttribute("registered_on", register_on);
                    }
                    if (email) {
                        window.webengage.user.setAttribute("we_email", email);
                    }
                    if (phone) {
                        window.webengage.user.setAttribute("we_phone", phone.replaceAll(' ', ''));
                    }
                    if (fromTest) {
                        window.webengage.track('registered_on', {
                            date: register_on,
                            type: 'psyregister'
                        });
                    } else {
                        window.webengage.track('registered_on', {
                            date: register_on,
                        });
                    }
                    this.WebengageSetUserLoggedIn(userId)
                    console.log('sent register data to web engage')
                } catch (error) {
                    console.log('have problem in send data to webengage' + error)
                }
            }
            // console.log('ok')
        },
        WebengageProceedToPayment() {
            this.sendToWebengage('proceed_to_payment')
        },
        CouponCodeWebengageTrack(code, status) {
            let payload = {
                code: code
            }
            if (status == 'success') {
                this.sendToWebengage('promotion_code_success', payload)
            } else if (status == 'failed') {
                this.sendToWebengage('promotion_code_failure', payload)
            }
        },
        sendToWebengage(event, data) {
            if (window.webengage) {
                window.webengage.track(event, data);
            }
        },
        sendAddToCartEvents(resp) {
            let addedPackage = resp.data.package;
            let product = {
                'name': addedPackage.title,
                'id': addedPackage.id,
                'price': addedPackage.pivot.price,
                'brand': 'Simiaroom',
                'category': 'Counseling',
                'quantity': 1
            };

            if (window.webengage) {
                window.webengage.track('add_to_cart', product);
            }

            this.$gtm.trackEvent({
                'event': 'eec.addToCart',
                'ecommerce': {
                    'add': {
                        'products': [product]
                    }
                }
            });
        },
        prepareProductsForEvents(cart) {
            let products = [];
            Object.keys(cart.items).forEach((key) => {
                let item = cart.items[key];
                products.push({
                    'name': item.item.title,
                    'id': item.item.id,
                    'price': item.price,
                    'brand': 'Simiaroom',
                    'category': 'Counseling',
                    // 'variant': 'Gray',
                    'quantity': item.qty
                })
            })
            return products
        },
        GTMAddToCart(item) {
            this.$gtm.trackEvent({
                'event': 'eec.addToCart',
                'ecommerce': {
                    'add': {
                        'products': [{
                            'name': item.item.title,
                            'id': item.item.id,
                            'price': item.price,
                            'brand': 'Simiaroom',
                            'category': 'Counseling',
                            // 'variant': 'Gray',
                            'quantity': 1
                        }]
                    }
                }
            });
        },
        WebengageAddToCart(item) {
            let product = {
                'name': item.item.title,
                'id': item.item.id,
                'price': item.price,
                'brand': 'Simiaroom',
                'category': 'Counseling',
                'quantity': 1
            };

            this.sendToWebengage('add_to_cart', product)

        },

        GTMRemoveFromCart(item) {
            this.$gtm.trackEvent({
                'event': 'eec.removeFromCart',
                'ecommerce': {
                    'remove': {                               // 'remove' actionFieldObject measures.
                        'products': [{
                            'name': item.item.title,
                            'id': item.item.id,
                            'price': item.price,
                            'brand': 'Simiaroom',
                            'category': 'Counseling',
                            // 'variant': 'Gray',
                            'quantity': 1
                        }]
                    }
                }
            });
        },
        WebEngagePreSessionSet(data) {
            if (window.webengage) {
                window.webengage.track('book_pre_session', data);
            }
        },
        RegisterUserInTrk() {
            if (!localStorage.getItem('trk_id')) {
                let anon = this.generateRandomAnonId();
                let profile = this.$store.getters.getProfile
                localStorage.setItem('anon', anon)
                let payload = {
                    anon_id: anon,
                    email: profile.email,
                    first_name: null,
                    traits: {}
                }
                return axios.post('https://trk.simiaroom.com/webhook/identify', payload).then(() => {
                    localStorage.setItem('trk_id', anon)
                })
            }
        },
        generateRandomAnonId() {
            const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let result = '';
            for (let i = 0; i < 12; i++) {
                result += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return result;
        },
        SendEventTrk(data) {
            let profile = this.$store.getters.getProfile
            const phone = data.phone || data.payload?.phone || profile?.mobile || profile?.cel
            const properties = { ...(data.payload || {}) }
            if (phone) {
                properties.phone = phone.replaceAll(' ', '')
            }
            let payload = {
                event_id: data.event_id,
                anon_id: localStorage.getItem('trk_id'),
                name: data.name,
                first_name: data.first_name,
                last_name: data.last_name,
                email: data.email,
                properties,
                auth_id: profile.auth_id,
                occurred_at: new Date().toISOString()
            }
            return axios.post('https://trk.simiaroom.com/webhook/track', payload)
        },
        getMainZoneScore(report) {
            const mainResult = report?.result?.[0]
            if (!mainResult?.score) return null
            const score = mainResult.score
            if (score.sum != null) return score.sum
            if (score.average != null) return score.average
            return typeof score === 'number' ? score : null
        },
        sendPsychologicalTestWebhook(testId, report) {
            const testScore = this.getMainZoneScore(report)
            if (testScore == null) return Promise.resolve()
            const profile = this.$store.getters.getProfile
            return axios.post('https://trk.simiaroom.com/webhook/psychological_test', {
                test_id: testId,
                test_score: testScore,
                email: profile?.email ?? null,
                user_id: profile?.id ?? null,
            })
        },
        SetAttributeTrackerService(email, payload) {
            let body = {
                email: email,
                attributes: payload
            }
            axios.post('https://trk.simiaroom.com/events-core/set-attribute', body)
        },
    }
}